import React, { useState, useContext, useEffect, useRef } from "react";
import "./SidebarHeader.css"; // Import CSS for styling
import "./ai-tasks/ai-tasks.css";
import NotificationBell from "./reusable/notification-bell";
import tigerX from "../images/tigerX.png";
import BChatLogo from "../images/buildhub-chat-logo.png";
import profileFiller from "../images/empty.jpg";

import { userLogout } from "../hooks/accountHandler";
import { useNavigate } from "react-router-dom";
import { ChatContext, WebSocketContext } from "../context/contexts";
import {
  useSupport,
  initSupport,
  logoutSupport,
  selectBadgeCount,
} from "../hooks/supportStore";

function SidebarHeader(props) {
  const Chat = useContext(ChatContext);
  const WS = useContext(WebSocketContext);
  const navigate = useNavigate();

  const {
    userDetails,
    showHideChangePasswordModal,
    showAiChatbot,
    setShowAiChatbot,
    showAITasks,
    setShowAITasks,
    pendingTaskCount,
  } = props;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const profileMenuRef = useRef(null);

  // Customer support: only connects (and shows the button) for cs_access users.
  const support = useSupport();
  const supportBadge = support.enabled ? selectBadgeCount(support) : 0;
  useEffect(() => {
    initSupport();
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    if (!isDropdownOpen) return;

    const handleOutsideClick = (event) => {
      if (!profileMenuRef.current?.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isDropdownOpen]);

  const userProfile =
    userDetails &&
    userDetails.profile_photo &&
    userDetails.profile_photo !== null &&
    userDetails.profile_photo !== ""
      ? `${process.env.REACT_APP_IMAGES_DATA_RESOURCES_URL}/${userDetails.profile_photo}`
      : profileFiller;
  const handleLogout = () => {
    userLogout();
    WS.websocketInstance.logout();
    logoutSupport();
    navigate("/login");
  };
  const IS_ADMIN = userDetails && userDetails.admin_access === true;
  return (
    <div
      className={`sidebar-header ${
        Chat.isMobileMode && Chat.isMobileChatDetailShow
          ? "sidebar-header-hide"
          : ""
      }`}
    >
      <div className="sidebar-header__top">
        <img
          src={BChatLogo}
          alt="BuildHub Chat"
          onClick={() => navigate("/")}
          className="sidebar-header-logo"
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              navigate("/");
            }
          }}
        />
      </div>

      <div className="sidebar-header__actions">
        {IS_ADMIN && (
          <button
            className={`sidebar-header__nav-btn${
              showAiChatbot ? " sidebar-header__nav-btn--active" : ""
            }`}
            onClick={() =>
              setShowAiChatbot && setShowAiChatbot((prev) => !prev)
            }
            title="Tiger X AI Assistant (Admin Only)"
            aria-label="Toggle Tiger X AI Assistant"
            aria-pressed={!!showAiChatbot}
          >
            <img
              src={tigerX}
              alt="Tiger X AI Assistant"
              className="sidebar-header__nav-icon"
            />
          </button>
        )}

        <button
          className={`sidebar-header__nav-btn${
            showAITasks ? " sidebar-header__nav-btn--active" : ""
          }`}
          onClick={() => setShowAITasks && setShowAITasks((prev) => !prev)}
          title="AI Tasks"
          aria-label="Toggle AI Tasks"
          aria-pressed={!!showAITasks}
        >
          <i className="fa fa-tasks sidebar-header__task-icon" />
          {pendingTaskCount > 0 && (
            <span className="ai-tasks-nav-badge">{pendingTaskCount}</span>
          )}
        </button>

        {support.enabled && (
          <button
            className="sidebar-header__nav-btn"
            onClick={() => navigate("/support")}
            title="Customer Support"
            aria-label={`Customer Support${supportBadge ? `, ${supportBadge} need attention` : ""}`}
          >
            <i className="fa fa-headphones sidebar-header__task-icon" />
            {supportBadge > 0 && (
              <span className="ai-tasks-nav-badge">
                {supportBadge > 99 ? "99+" : supportBadge}
              </span>
            )}
          </button>
        )}
      </div>

      <div className="sidebar-header__profile-section" ref={profileMenuRef}>
        <NotificationBell
          addtlClass={"notif-side-header"}
          userId={userDetails?.id}
          displayName={userDetails?.display_name}
        />
        <button
          type="button"
          className="sidebar-header__profile-trigger"
          onClick={toggleDropdown}
          aria-haspopup="menu"
          aria-expanded={isDropdownOpen}
          aria-label="Open profile menu"
        >
          <img
            src={userProfile}
            alt="User Profile"
            className="sidebar-header__profile-photo"
          />
        </button>
        {isDropdownOpen && (
          <div className="sidebar-header__dropdown" role="menu">
            <button
              type="button"
              className="sidebar-header__dropdown-item"
              onClick={() => navigate("/profile")}
            >
              My Profile
            </button>
            <button
              type="button"
              className="sidebar-header__dropdown-item"
              onClick={() => navigate("/requests?p=view-requests")}
            >
              My Request
            </button>
            {support.me?.admin_access && (
              <button
                type="button"
                className="sidebar-header__dropdown-item"
                onClick={() => navigate("/support?view=agents")}
              >
                Support Agents
              </button>
            )}
            <button
              type="button"
              className="sidebar-header__dropdown-item"
              onClick={() => showHideChangePasswordModal()}
            >
              Change Password
            </button>
            <button
              type="button"
              className="sidebar-header__dropdown-item"
              onClick={() => handleLogout()}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SidebarHeader;
